import { atom } from "jotai";

export const potentialSystemsAtom = atom<string>("");

potentialSystemsAtom.debugLabel = "potentialSystemsAtom";
